import type ApplicationInstance from '@ember/application/instance';
import type Notifications from '../services/notifications';

const EXIT_TIMEOUT_MS = 3000;
const EXIT_WARNING = 'Press back again to exit';

export function initialize(appInstance: ApplicationInstance): void {
  void (async () => {
    try {
      const { Capacitor } = await import('@capacitor/core');
      if (!Capacitor.isNativePlatform()) return;

      const { App } = await import('@capacitor/app');
      const notifications = appInstance.lookup(
        'service:notifications'
      ) satisfies Notifications;

      let exitPending = false;
      let exitTimer: ReturnType<typeof setTimeout> | null = null;

      App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
          return;
        }

        if (exitPending) {
          if (exitTimer !== null) {
            clearTimeout(exitTimer);
            exitTimer = null;
          }
          void App.exitApp();
          return;
        }

        exitPending = true;
        notifications.warning(EXIT_WARNING, { duration: EXIT_TIMEOUT_MS });

        exitTimer = setTimeout(() => {
          exitPending = false;
          exitTimer = null;
        }, EXIT_TIMEOUT_MS);
      }).catch(() => {
        // addListener is synchronous-like but returns a promise for the handle;
        // swallow any unexpected rejection.
      });
    } catch {
      // Not a Capacitor environment — no-op.
    }
  })();
}

export default { initialize };
